import { Component, OnInit, ViewChild, ElementRef, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { ApiService } from '../../pages/_api-service/api.service';
import { AppService } from 'src/app/app.service';
import { CacheService } from '../../pages/cache-service/cache.service';
import { isLocal, isTestUser } from '../../utils';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private apiService: ApiService,
    private cacheService: CacheService,
    private appService: AppService
  ) { }

  public fullName: any = "User";
  public email: any;

  ngOnInit(): void {

    if (this.appService.getisLoggedIn()) {
      this.fullName = this.appService.getName();
      this.email = this.appService.getEmail();
    }

    this.fullName = this.appService.getName() ? this.appService.getName() : "User";

    this.email = this.appService.getEmail();
    if (!this.email) {
      this.email = this.appService.getUserId();
    }

  }

  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(e) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  /**
   * Logout
   */
  onLogout(e) {
    e.preventDefault();
    localStorage.removeItem('isLoggedIn');
    localStorage.clear();

    if (!localStorage.getItem('isLoggedIn')) {
      this.router.navigate(['/auth/login']);//here
      this.cacheService.clear();
    }
  }

  isDev(): boolean {
    let userid = this.appService.getUserId();
    return isLocal() || isTestUser(userid);
  }

  refreshCache(): void {
    this.apiService.refeshCache();
  }

}
